export default "__VITE_ASSET__Cd69oW3H__"